import { render, staticRenderFns } from "./PdfViewBase.vue?vue&type=template&id=089aa4df&"
import script from "./PdfViewBase.vue?vue&type=script&lang=js&"
export * from "./PdfViewBase.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports